import React from 'react';
type Props = {
  tone?: 'light' | 'dark' | 'blush';
};
const lines = {
  light: 'border-mist-line',
  dark: 'border-[rgba(170,185,210,0.09)]',
  blush: 'border-blush-line'
};

/**
 * Vertical hairlines at the left/right content edges. Placed in every section
 * so the rails read as one continuous line down the whole page.
 */
export function GridRails({
  tone = 'light'
}: Props) {
  return <div aria-hidden="true" className="pointer-events-none absolute inset-0 z-[5]" data-id="element-232" data-mp="2l8camycxi7l5">
      <div className="mx-auto h-full max-w-[1720px] px-5 md:px-16 lg:px-24" data-id="element-233" data-mp="2q6m85fm4lk9x">
        <div className={`h-full border-x ${lines[tone]}`} data-id="element-234" data-mp="2q8qlsp9ttxne" />
      </div>
    </div>;
}